import instance from '../utils/axios';

export interface DupattaTypeData {
  id: number;
  name: string;
  description?: string;
  isActive: boolean;
}

export interface JobWorkSummary {
  id: number;
  jobWorkCode: string;
  vendorName: string;
  jobType: string;
  status: string;
  issueDate: string;
  agingDays: number;
  qty: number;
}

export interface BarcodedBatchInfo {
  batchNumber: string;
  totalBarcoded: number;
}

export interface POSummary {
  id: number;
  po_number: string;
  status: string;
  vendor: string;
  totalQty: number;
  garmentParts: string[];
}

export type DupattaDesignStatus = 'ACTIVE' | 'COMPLETED';

export interface DupattaDesignRecord {
  id: number;
  designNo: string;
  description?: string | null;
  quantity: number;
  status: DupattaDesignStatus;
  dupattaImageUrl?: string | null;
  dupattaType?: DupattaTypeData;
  design?: {
    design_no: string;
    name?: string;
    product_type?: string;
    approval_status: string;
    image_url?: string | null;
  };
  jobWorks: JobWorkSummary[];
  barcodedBatch: BarcodedBatchInfo | null;
  topCutQty?: number | null;
  purchaseOrders: POSummary[];
}

const dupattaDesignsApi = {
  getAll: (params?: { search?: string; status?: string }): Promise<DupattaDesignRecord[]> =>
    instance.get('/dupatta-designs', { params }).then((r) => r.data),

  create: (data: {
    designNo: string;
    dupattaTypeId?: number | null;
    description?: string;
    quantity?: number;
    dupattaImageUrl?: string | null;
  }): Promise<DupattaDesignRecord> =>
    instance.post('/dupatta-designs', data).then((r) => r.data),

  update: (
    id: number,
    data: {
      dupattaTypeId?: number | null;
      description?: string;
      quantity?: number;
      dupattaImageUrl?: string | null;
    }
  ): Promise<DupattaDesignRecord> =>
    instance.put(`/dupatta-designs/${id}`, data).then((r) => r.data),

  setStatus: (id: number, status: DupattaDesignStatus): Promise<DupattaDesignRecord> =>
    instance.patch(`/dupatta-designs/${id}/status`, { status }).then((r) => r.data),

  delete: (id: number): Promise<void> =>
    instance.delete(`/dupatta-designs/${id}`).then((r) => r.data),
};

export default dupattaDesignsApi;
